import { AsmAutomationViewId } from '../models/asm-automation-view-id';
import { AsmAutomationType } from '../models/asm-automation-type';
import { TypeService, ViewService } from '@sol/components';

export function provideAsmAutomationViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmAutomationType.automationActionItem);
  viewService.addView(
    AsmAutomationType.automationActionItem.array,
    'edit',
    AsmAutomationViewId.automationActionEdit,
    () =>
      import('../components/view/asm-view-edit-automation-action/asm-view-edit-automation-action.component').then(
        m => m.AsmViewEditAutomationActionComponent,
      ),
    true,
  );
}
